import { MoreLikeThisBase } from "./MoreLikeThisBase.js";

export class MoreLikeThisUsingAnyDocument extends MoreLikeThisBase {
    // empty
}
